export const version = {
  timeStamp: '2026-10-05 04:30:57 PM -03',
  version: '0.0.13-20261005163057',
}
